// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"65d987bb","680":"838b275d","755":"f6d35ae9","802":"4d639724","965":"e7ed2b10"}[chunkId] + ".chunk.js";
};